<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">RIGHT HO, JEEVES</h1>
<h3 class="calibre2" id="pgepubid00001">By</h3>
<h2 class="calibre3" id="pgepubid00002">P. G. WODEHOUSE</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?4949a7c8